import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchBlocks = createAsyncThunk(
  "block/fetchBlocks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // filterField is expected to be either 'created_at' or 'updated_at'
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  const dateKey = `${filterField}_${
                    key === "from_date" ? "from" : "to"
                  }`;
                  params.append(dateKey, String(value));
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await Axios.get(`/block/?${params.toString()}`);
    // const response: any = await Axios.get(`/block/`, {
    //   params: {
    //     page,
    //     page_size: pageSize,
    //     search: search || undefined,
    //     filters: filters ? JSON.stringify(filters) : undefined,
    //   },
    // });
    return {
      data: response.data.results || [],
      rowCount: response.data.total_records || 0,
    };
  }
);

export const fetchBlockById = createAsyncThunk(
  "block/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/block/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch block by ID"
      );
    }
  }
);

export const fetchBlockByDropDown = createAsyncThunk(
  "Block/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/block/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Block list"
      );
    }
  }
);

export const fetchlocksBasedOnSelectedPackageAndDistrict = createAsyncThunk(
  "block/fetchByPackageAndDistrict",
  async (
    { packageId, distId }: { packageId: string; distId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.get(
        `${API_URL}/block/dropdown/blocks/?package_id=${packageId}&district_id=${distId}`
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch blocks");
    }
  }
);

export const updateBlock = createAsyncThunk(
  "block/updateBlock",
  async (blockData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `/block/${blockData.id}/update/`,
        blockData
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to update block" }
      );
    }
  }
);

export const updateStatusInBlock = createAsyncThunk(
  "block/updateStatusInBlock",
  async (blockData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: blockData.is_active };
      const response: any = await Axios.put(
        `/block/status/${blockData.id}/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to update status in  block" }
      );
    }
  }
);

export const addBlock = createAsyncThunk(
  "block/addBlock",
  async (blockData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`/block/create/`, blockData);
      // console.log("response while addign block : ", response);
      return response.data;
    } catch (err: any) {
      // throw err
      return rejectWithValue(
        err.response?.data || { message: "Failed to add block" }
      );
      // return err.response?.data || "Failed to add block";
    }
  }
);

export const deleteBlock = createAsyncThunk(
  "block/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`/block/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportBlockCSV = async () => {
//   const response = await Axios.get("/block/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "block.csv",
//   };
// };

export const exportBlockCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/block/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "block.csv",
  };
};
